import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as announcementEventApi from '../../api/announcementEventApi';

export const fetchAnnouncementEvents = createAsyncThunk(
  'announcementEvent/fetch',
  async (params = {}, { rejectWithValue }) => {
    try {
      return await announcementEventApi.fetchAnnouncementEvents(params);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Erreur lors du chargement.');
    }
  }
);

export const fetchAnnouncementEventById = createAsyncThunk(
  'announcementEvent/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      return await announcementEventApi.fetchAnnouncementEventById(id);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Annonce ou événement introuvable.');
    }
  }
);

export const createAnnouncementEvent = createAsyncThunk(
  'announcementEvent/create',
  async (payload, { rejectWithValue }) => {
    try {
      return await announcementEventApi.createAnnouncementEvent(payload);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Erreur lors de la création.');
    }
  }
);

export const updateAnnouncementEvent = createAsyncThunk(
  'announcementEvent/update',
  async ({ id, ...payload }, { rejectWithValue }) => {
    try {
      return await announcementEventApi.updateAnnouncementEvent(id, payload);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Erreur lors de la mise à jour.');
    }
  }
);

export const deleteAnnouncementEvent = createAsyncThunk(
  'announcementEvent/delete',
  async (id, { rejectWithValue }) => {
    try {
      await announcementEventApi.deleteAnnouncementEvent(id);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Erreur lors de la suppression.');
    }
  }
);

const announcementEventSlice = createSlice({
  name: 'announcementEvent',
  initialState: {
    list: [],
    current: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearCurrent: (state) => {
      state.current = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAnnouncementEvents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAnnouncementEvents.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload || [];
      })
      .addCase(fetchAnnouncementEvents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchAnnouncementEventById.fulfilled, (state, action) => {
        state.current = action.payload;
      })
      .addCase(createAnnouncementEvent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createAnnouncementEvent.fulfilled, (state, action) => {
        state.loading = false;
        state.list = [action.payload, ...state.list];
      })
      .addCase(createAnnouncementEvent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateAnnouncementEvent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateAnnouncementEvent.fulfilled, (state, action) => {
        state.loading = false;
        const i = state.list.findIndex((x) => x._id === action.payload._id);
        if (i >= 0) state.list[i] = action.payload;
        if (state.current?._id === action.payload._id) state.current = action.payload;
      })
      .addCase(updateAnnouncementEvent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteAnnouncementEvent.fulfilled, (state, action) => {
        state.list = state.list.filter((x) => x._id !== action.payload);
        if (state.current?._id === action.payload) state.current = null;
      });
  },
});

export const { clearCurrent, clearError } = announcementEventSlice.actions;
export default announcementEventSlice.reducer;
